<div style="display: flex; align-items: center">
  <span class="ng-option-label" style="overflow: hidden; width: 100%; text-overflow: ellipsis"
    #t="ngbTooltip" [autoClose]="true" triggers="manual" (touchstart)="t.open()" (touchend)="t.close()"
    (mouseover)="t.open()" (mouseleave)="t.close()" [ngbTooltip]="tooltip ? tooltip : null">{{name}}</span>
  <i (click)="click()" style="float: right; font-size: 17px; color: #3F88C5" [class]="icon"></i>
</div>